import { Component } from '@angular/core';

@Component({
  selector: 'engraving-routing',
  template: `
    <article class="component">
      <h1>Gravuren</h1>
      <router-outlet></router-outlet>
    </article>
  `,
  styles: [ 'section table { width: 100%; }' ]
})
export class EngravingEntryView {}
